'use strict';
import { module } from '../app';

module.controller('PatientsListCtrl', [
  '$scope', 'patientsListViewModel', 'signalrService', '$state', 'modalService',
  function ($scope, viewModel, signalrService, $state, modalService) {
    $scope.vm = new viewModel();
    $scope.isOnline = () => signalrService.isConnected;

    $scope.goToPatientDetail = async (patient) => {
      if ($scope.isOnline()) {
        $state.go('root.patient_details', {accessToken: patient.AccessToken});
      } else {
        await modalService.showAlertAsync(`You are currently offline, please check your network settings and try again`);
        if (!$scope.reconnectTimeout) {
          $scope.reconnectTimeout = setTimeout(() => {
            signalrService.tryReconnectAgain();
            clearTimeout($scope.reconnectTimeout);
          }, 10000);
        }
      }
    }
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/patientsList.js